import { render, staticRenderFns } from "./competition-supervise.vue?vue&type=template&id=1c4c9096&scoped=true&"
import script from "./competition-supervise.vue?vue&type=script&lang=js&"
export * from "./competition-supervise.vue?vue&type=script&lang=js&"
import style0 from "./competition-supervise.vue?vue&type=style&index=0&id=1c4c9096&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c9096",
  null
  
)

export default component.exports